<!----复杂筛选框组件----->
<template>
  <div class="popover-mask" v-show="visible" @click="onHide">
    <el-popover ref="select_popover" placement="right" v-model="visible" v-nobubble>
      <div class="row-tb-head" style="margin-bottom: 5px;" v-if="create">
        <div style="float: right;">
          <el-button type="primary" icon="el-icon-plus" @click="onCreate">添加</el-button>
        </div>
      </div>
      <el-table
        ref="table"
        :empty-text="empty"
        :data="data"
        @row-click="selectRow"
        :height="height"
        v-loading="loading"
        highlight-current-row
      >
        <template v-for="(i,key) in tbHead">
          <el-table-column
            :key="key"
            :label="i.Name"
            :min-width="i.Width"
            :prop="i.Value"
            show-overflow-tooltip
          />
        </template>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageParams.pageIndex"
        :page-size="pageParams.pageSize"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </el-popover>
  </div>
</template>
<script>
// import pageModule from "@/components/common/pageModule";
export default {
  // components: { pageModule },
  props: {
    /*分页相关参数*/
    isPage: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    /*分页相关参数*/

    /*表格相关参数*/
    //表格最大高度
    height: {
      type: String,
      default: "300",
    },
    //表头
    tbHead: {
      type: Array,
      default: () => [],
    },
    //表数据，如果不传，则 getDataFunc 必传
    //如果数据量过大时，建议使用 getDataFunc 的方式
    tbData: {
      type: Array,
      default: () => [],
    },
    empty: {
      type: String,
      default: "暂无数据",
    },
    //搜索关键字
    keyword: {
      type: String,
      default: "",
    },
    params: {
      type: Object,
      default: () => {},
    },
    /*表格相关参数*/

    //获取数据的接口，如果不传，则 tbData 必传
    getDataFunc: {
      type: Function,
      default: undefined,
    },
    //查询不到的数据是否可以创建
    create: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false, //是否显示
      search: "", //搜索的文本
      data: [],
      inputEle: null,
      wrapper: null,
      loading: false,
      total: 0,
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: 1,
      },
      timeout: null, //防抖定时器
      keys: ["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft", "Enter"],
      moveCodes: ["Numpad8", "Numpad6", "Numpad2", "Numpad4"],
      currentIndex: 0, //表格选中的数据下标
    };
  },
  mounted() {},
  computed: {},
  watch: {
    visible() {
      // console.log("watch", this.visible);
      if (this.visible == false) {
        document.removeEventListener("keyup", this.ListenerFunc);
        this.currentIndex = 0;
        this.pageParams.pageIndex = 1;
        this.total = 0;
        this.data = [];
      }
    },
  },
  methods: {
    onShow(data) {
      // console.log("onShow", data);
      this.inputEle = data.el;
      this.search = data.val;
      //获取当前输入框的位置
      var pos = data.el.getBoundingClientRect();
      var left = pos.left - 2;
      var top = pos.top + pos.height + 10;

      var popover = this.$refs.select_popover.$el.firstChild;
      //设置选择框的位置
      popover.setAttribute("style", `left: ${left}px;top: ${top}px;`);

      document.addEventListener("keyup", this.ListenerFunc);

      var tb_children = Array(...this.$refs.table.$el.children);
      this.wrapper = tb_children.find(
        (x) => x.className.indexOf("el-table__body-wrapper") != -1
      );
      // console.log("input", [this.inputEle]);
      // console.log("wrapper", [this.wrapper]);

      this.visible = true;

      if (this.getDataFunc) {
        /*防抖，短时间内连续输入不会重复调用查询方法*/
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.pageParams.pageIndex = 1;
          this.onFilter();
        }, 500);
      } else {
        this.onLocalFilter();
      }
    },
    ListenerFunc(e) {
      // console.log(e.code, e.key);
      if (this.moveCodes.indexOf(e.code) != -1) {
        this.visible = false;
        return;
      }

      if (this.keys.indexOf(e.key) == -1) return;

      if (this.loading) return;

      if (e.code == "ArrowUp") {
        if (this.currentIndex > 0) {
          this.currentIndex--;
        } else {
          if (this.pageParams.pageIndex > 1) {
            this.pageParams.pageIndex--;
            this.handleCurrentChange();
          }
        }
      }
      if (e.code == "ArrowDown") {
        if (this.currentIndex < this.data.length - 1) {
          this.currentIndex++;
        } else {
          var now_count = this.pageParams.pageIndex * this.pageParams.pageSize;
          if (now_count < this.total) {
            this.pageParams.pageIndex++;
            this.handleCurrentChange();
          }
        }
      }

      var data = this.data[this.currentIndex];
      if (data) {
        // console.log("index", this.currentIndex);
        // console.log(e.code, data.GoodsName);
        this.$refs.table.setCurrentRow(data);
        if (e.code == "Enter") this.selectRow(data);
      } else {
        if (e.code == "Enter") this.selectRow(null);
      }

      this.$nextTick(() => {
        var tb_el = this.$refs.table.$el;
        var current = tb_el.querySelector(".current-row");
        if (current) this.wrapper.scrollTop = current.offsetTop;
      });
    },
    onHide() {
      // console.log("onHide");
      this.visible = false;
    },
    getParams() {
      var params = this.$commonJs.obj.removeNullKey(this.params);
      params = { ...params, [this.keyword]: this.search };
      if (this.isPage) params = { ...params, ...this.pageParams };
      return params;
    },
    onFilter() {
      console.log("接口查询");
      this.loading = true;
      var params = this.getParams();
      this.getDataFunc(params).then((res) => {
        // console.log("res", res);
        this.loading = false;
        this.currentIndex = 0;
        if (res.Code == 0) {
          this.data = res.Data;
          this.total = res.Count;
          this.$nextTick(() => {
            this.wrapper.scrollTop = 0;
            if (this.data.length > 0) {
              this.$refs.table.setCurrentRow(this.data[0]);
            }
          });
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    handleCurrentChange() {
      if (this.getDataFunc) {
        this.onFilter();
      } else {
        this.onLocalFilter();
      }
    },
    onLocalFilter() {
      // console.log("本地查询");
      var source = this.tbData;
      this.currentIndex = 0;

      if (this.search) {
        source = source.filter(
          (x) => x[this.keyword].indexOf(this.search) != -1
        );
      }

      var p_size = this.pageParams.pageSize;
      var p_index = this.pageParams.pageIndex;
      this.total = source.length;

      var offset = (p_index - 1) * p_size;
      if (offset + p_size >= source.length) {
        this.data = source.slice(offset, source.length);
      } else {
        this.data = source.slice(offset, offset + p_size);
      }

      this.$nextTick(() => {
        this.wrapper.scrollTop = 0;
        if (this.data.length > 0) {
          this.$refs.table.setCurrentRow(this.data[0]);
        }
      });
    },
    selectRow(row) {
      this.$emit("select", row);
      this.visible = false;
    },
    onCreate() {
      if (!this.create) return;
      this.$emit("on-create");
    },
  },
};
</script>
<style lang="scss">
.popover-mask {
  // background-color: #f0f8ff33;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
</style>